import React from 'react';

const spinnerTextStyles = {
    textAlign: 'center',
    transform: 'translateY(50px)'
}

const Spinner = ({ text }) => {

    return (
        <div className="spinner-wrap">
            <div className="Spinner tccloader"></div>
            {text && (<div className="spinnder-text" style={spinnerTextStyles}>{text}</div>)}
        </div>
    );

}

export default Spinner;
